import * as Sentry from '@sentry/react';

type ApiFailureType = 'http_error' | 'network_error' | 'timeout';

interface ReportApiErrorParams {
  service: 'core' | 'tomtom';
  method: string;
  // The path argument as passed to the API wrapper — NEVER the built URL,
  // which embeds the JWT (see apiCall.ts) and would leak it to Sentry.
  path: string;
  // 0 for network errors / timeouts, where no HTTP status is available.
  status: number;
  failureType: ApiFailureType;
  // The parsed error response body, when the request reached the server.
  responseBody?: unknown;
}

const reportApiError = ({
  service,
  method,
  path,
  status,
  failureType,
  responseBody,
}: ReportApiErrorParams) => {
  const error = new Error(
    `${service} API ${method} failed (${failureType}${status ? ` ${status}` : ''})`,
  );
  error.name = 'ApiError';

  Sentry.captureException(error, {
    // Group by service + method + status (or failure type when there is no
    // status) so the high-cardinality path/query does not fragment issues.
    fingerprint: ['api-error', service, method, String(status || failureType)],
    tags: {
      'api.service': service,
      'api.method': method,
      'api.status': status,
      'api.failure_type': failureType,
    },
    contexts: {
      api: { service, method, path, status, failureType, responseBody },
    },
  });
};

export default reportApiError;
